import endpointUrls from 'global/Constants/endpointUrls';
import { dateObjectFormatter } from 'global/helperFunctions/dateFormatter';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { useState } from 'react';
import { utils, write } from 'xlsx';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { CloudDownloadOutlined } from '@ant-design/icons';
import { message } from 'antd';
import TcButton from 'components/UI/button/TcButton';
import { saveAs } from 'file-saver';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import { branchCustomerProduct } from 'global/Models/branchCustomerProductTypeModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';
const name = 'گزارش اکسل فولفیلمنت';

const BranchCustomerProductExcel = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const exportToCSV = () => {
    setLoading(true);
    const array: any[] = [];
    ApiService.post(endpointUrls.branchCustomerProductGetAllForExcel, {})
      .then((res: IBackendSearchGeneric<branchCustomerProduct>) => {
        if (res.isSuccess) {
          res.data.map((item: branchCustomerProduct, index: number) => {
            array?.push({
              ردیف: index + 1,
              ' تاریخ ثبت': dateObjectFormatter(item?.modificationDate),
              'نام کاربر': item.customerTitle,
              نمایندگی: item.branchTitle,
              'نام کالا': item.customerProductTitle,
              'تعداد کالا': item.amount,
              'تعداد کالای سفارش داده شده': item.decreaseAmount,
              بارکد: item.parcelBarcode,
              وضعیت: item.statusTitle,
            });
          });
          const ws = utils.json_to_sheet(array);
          const wscols = [{ wch: 6 }, { wch: 20 }, { wch: 25 }, { wch: 25 }, { wch: 20 }, { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 25 }];

          ws['!cols'] = wscols;
          const wb = { Sheets: { data: ws }, SheetNames: ['data'], Workbook: { Views: [{ RTL: true }, { RTL: true }] } };
          const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
          const data = new Blob([excelBuffer], { type: fileType });
          saveAs(data, name + fileExtension);
        } else {
          message.error(res.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        localApiCatcher(errorResponse);
      });
  };
  return (
    <div className='mb-3'>
      <TcButton type='default' loading={loading} className='mb-3' onClick={() => exportToCSV()}>
        <CloudDownloadOutlined /> دریافت فایل اکسل
      </TcButton>
    </div>
  );
};
export default BranchCustomerProductExcel;
